module.exports = __webpack_public_path__ + "img/nature-46.e6009a44.jpg";